import api from './api';

/**
 * Client-side service for communicating with the server's Jev integration
 */
const typesafeService = {
  estimateEffort: async (ticket) => {
    const response = await api.post('/jev/estimate', { ticket });
    return response.data.hours;
  }
};

export default typesafeService;